import { PROGRAM_IDS } from "../constants/programs";
import { LearningObjective, ProgramData, ProgramSkill } from "../types/Interfaces";

export namespace ProgramUtils {
  export function getLearningOutcomesFromRole(programID: string = ""): boolean {
    return [PROGRAM_IDS.SWAST_SP_AP_RP, PROGRAM_IDS.NWAS_ARC].includes(programID);
  }

  export function getAllLearningOutcomesFromRoles(program: ProgramData): LearningObjective[] {
    const programRoles = program.Roles ?? [];
    const learningObjectives = programRoles.flatMap((role) => role["Learning Objective"] ?? []);

    const uniqueById = new Map<string, LearningObjective>();

    for (const learningObjective of learningObjectives) {
      if (!uniqueById.has(learningObjective.ID)) {
        uniqueById.set(learningObjective.ID, learningObjective);
      }
    }

    return Array.from(uniqueById.values());
  }

  export function getAllSkillsFromRoles(program: ProgramData | undefined): ProgramSkill[] {
    if (!program) return [];

    const roles = program.Roles ?? [];
    const skills = roles.flatMap((role) => role.Skills).filter((skill) => skill !== undefined) as ProgramSkill[];

    const uniqueSkills = new Map<string, ProgramSkill>();

    for (const skill of skills) {
      if (!uniqueSkills.has(skill.ID)) {
        uniqueSkills.set(skill.ID, skill);
      }
    }

    return Array.from(uniqueSkills.values());
  }
}
